var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVaultEmptyState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "empty 1",
    clipPath: "url(#clip0_66_4799)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M58.0876 11.7188H8.16311C7.48957 11.7192 6.84374 11.9869 6.36748 12.4632C5.89121 12.9394 5.62346 13.5853 5.62305 14.2588V60.065C5.62346 60.7385 5.89121 61.3843 6.36748 61.8606C6.84374 62.3369 7.48957 62.6046 8.16311 62.605H58.0876C58.7611 62.6047 59.407 62.337 59.8834 61.8607C60.3597 61.3844 60.6275 60.7386 60.6279 60.065V14.2588C60.6275 13.5852 60.3597 12.9394 59.8834 12.4631C59.407 11.9868 58.7611 11.7191 58.0876 11.7188Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M54.7971 46.6851H11.4463C10.0436 46.6851 8.90625 45.5478 8.90625 44.145V3.67288C8.90625 2.27012 10.0436 1.13281 11.4463 1.13281H54.7971C56.1999 1.13281 57.3372 2.27012 57.3372 3.67288V44.145C57.3372 45.5478 56.1999 46.6851 54.7971 46.6851Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.71045 44.9489V4.47707C9.71045 3.07432 10.8478 1.93701 12.2505 1.93701H55.6013C56.0968 1.93701 56.5574 2.08101 56.9479 2.32625C56.4989 1.61019 55.7047 1.13281 54.7971 1.13281H11.4463C10.0436 1.13281 8.90625 2.27012 8.90625 3.67288V44.145C8.90625 45.0528 9.38363 45.8468 10.0997 46.2961C9.85445 45.9053 9.71045 45.4447 9.71045 44.9492V44.9489Z",
    fill: "url(#paint0_linear_66_4799)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M49.464 9.6875H16.7812V11.5501H49.464V9.6875ZM49.464 16.7994H16.7812V18.6619H49.464V16.7994ZM49.464 23.9128H16.7812V25.7754H49.464V23.9128ZM49.464 31.0247H16.7812V32.8875H49.464V31.0247Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M20.6797 25.0078L28.8924 33.2208H20.6797V25.0078Z",
    fill: "url(#paint1_linear_66_4799)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M60.6286 33.9024V15.0058L57.3418 11.7188V33.9021H60.6286V33.9024Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M64.4745 35.6087L60.9333 60.6767C60.7562 61.93 59.6837 62.8614 58.4181 62.8614H7.82614C6.56056 62.8614 5.48804 61.93 5.31099 60.6767L0.525418 26.8037C0.309549 25.2745 1.49617 23.9082 3.04056 23.9082H18.6644C19.93 23.9082 21.0025 24.8396 21.1796 26.0926L21.8067 30.5285C21.9838 31.7818 23.0563 32.7132 24.3219 32.7132H61.9599C63.5038 32.7132 64.6907 34.0795 64.4748 35.6087H64.4745Z",
    fill: "url(#paint2_linear_66_4799)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M51.9275 51.6785H14.3173C14.1111 51.6784 13.9121 51.6032 13.7574 51.4669C13.6028 51.3306 13.5031 51.1426 13.4771 50.9381L13.0066 47.2124C12.9916 47.0932 13.0022 46.9722 13.0376 46.8574C13.073 46.7427 13.1323 46.6367 13.2118 46.5466C13.2912 46.4565 13.3889 46.3844 13.4984 46.3349C13.6079 46.2854 13.7266 46.2598 13.8467 46.2598H52.3981C52.5182 46.2598 52.6369 46.2854 52.7464 46.3349C52.8558 46.3844 52.9535 46.4565 53.033 46.5466C53.1124 46.6367 53.1718 46.7427 53.2072 46.8574C53.2426 46.9722 53.2531 47.0932 53.2382 47.2124L52.7676 50.9381C52.7417 51.1426 52.642 51.3306 52.4874 51.4669C52.3327 51.6032 52.1336 51.6784 51.9275 51.6785Z",
    fill: "#D5D5D5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_66_4799",
    x1: 34.6112,
    y1: 25.3956,
    x2: 2.48789,
    y2: -6.72791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_66_4799",
    x1: 26.1058,
    y1: 34.5386,
    x2: 16.1787,
    y2: 24.6117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2CECE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179,
    stopColor: "#AFBCBC",
    stopOpacity: 0.179
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B6A6A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_66_4799",
    x1: 32.5,
    y1: 23.9082,
    x2: 32.5,
    y2: 62.8614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927,
    stopColor: "#E4E4E4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_66_4799"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVaultEmptyState);
export default __webpack_public_path__ + "static/media/vault-empty-state.421a59371ebcf9128786bdb59ed31228.svg";
export { ForwardRef as ReactComponent };